/* eslint-disable simple-import-sort/sort */
import {
    trimCustomerAddress,
    trimCheckoutCustomerAddress,
    trimCheckoutAddress,
    removeEmptyStreets,
    setAddressesInFormObject,
    getFormFields,
    getCityAndRegionFromZipcode,
    // getDefaultAddressLabel,
    getAvailableRegions,
    getFormattedRegion,
    getRegionIdFromAvailableRegions,
    getRegionIdOfRegionName,
    checkIfStoreIncluded
} from 'SourceUtil/Address';

export {
    trimCustomerAddress,
    trimCheckoutCustomerAddress,
    trimCheckoutAddress,
    removeEmptyStreets,
    setAddressesInFormObject,
    getFormFields,
    getCityAndRegionFromZipcode,
    // getDefaultAddressLabel,
    getAvailableRegions,
    getFormattedRegion,
    getRegionIdFromAvailableRegions,
    getRegionIdOfRegionName,
    checkIfStoreIncluded
};

/** @namespace PeggysagePwa/Util/Address/Index/getDefaultAddressLabel */
export const getDefaultAddressLabel = (address) => {
    const { default_billing, default_shipping } = address;

    if (!default_billing && !default_shipping) {
        return '';
    }

    if (default_billing && default_shipping) {
        return __('Shipping & billing address');
    }

    if (default_billing) {
        return __('Billing address');
    }

    return __('Shipping address');
};

/** @namespace PeggysagePwa/Util/Address/Index/getAddressNotificationMessage */
export const getAddressNotificationMessage = (operation) => {
    switch (operation) {
    case 'edited':
        return __('You edited the address').toString();
    case 'deleted':
        return __('You deleted the address').toString();
    case 'saved':
        return __('You saved the address').toString();
    default:
        return __('You %s the address', operation).toString();
    }
};
